import axios from 'axios';
let BASE_URL = import.meta.env.VITE_APP_API_URL;
//const authStore = useAuthStore();
class ApiService {
    constructor() {
        this.axiosInstance = axios.create({
            baseURL: BASE_URL
        });
        this.setHeader('X-AppKey', 'do2pvnapdf_as');

        // Axios 인터셉터
        // this.axiosInstance.interceptors.response.use(
        //     (response) => response,
        //     (error) => {
        //         if (error.response && error.response.status === 415) {
        //             console.error('Content-Type 불일치 에러');
        //             error.isContentTypeError = true;
        //         }
        //         if (error.response && error.response.status === 401 && authStore.refreshToken) {
        //         }
        //         return Promise.reject(error);
        //     }
        // );
    }

    setBaseUrl(url) {
        if (!url) {
            throw new Error('Base URL 설정 요청');
        }
        BASE_URL = url;
        this.axiosInstance.defaults.baseURL = BASE_URL;
    }

    setHeader(key, value) {
        this.axiosInstance.defaults.headers.common[key] = value;
    }

    removeHeader(key) {
        delete this.axiosInstance.defaults.headers.common[key];
    }

    get(endpoint, params = {}) {
        return this.axiosInstance.get(endpoint, { params });
    }

    post(endpoint, data) {
        return this.axiosInstance.post(endpoint, data);
    }

    put(endpoint, data) {
        return this.axiosInstance.put(endpoint, data);
    }

    delete(endpoint) {
        return this.axiosInstance.delete(endpoint);
    }

    request(method, endpoint, data = null, params = {}, headers = {}) {
        if (!endpoint) return Promise.resolve(null);

        const url = endpoint.replace(/^\/+/, '');
        const mergedHeaders = {
            ...this.axiosInstance.defaults.headers.common, // 기존 설정된 헤더들
            ...headers // 요청 시 전달된 헤더들
        };

        return this.axiosInstance({
            method,
            url,
            data,
            params,
            headers: mergedHeaders
        }).catch((error) => {
            console.error('API request failed:', error);
            throw error;
        });
    }
}

export default new ApiService();
